import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { TIPOS_TURNOS, Turnos } from "../../../models/personal/turnos.model";
import { EmployeesListService } from "../employees-list.service";
import { TurnosService } from "../../../services/employees/turnos.service";
import { EmployeesListModel } from "../employees-list.model";
import { TurnosFormComponent } from "./turnos-form.component";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TurnosEliminarComponent } from "./turnos-eliminar.component";
import { EMPLOYEES_ROUTES } from "../const";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { RegistroHorasService } from "../../../services/employees/registro-horas.service";
import moment from 'moment';
import { Utils } from "../../../shared/utils";
import { consts } from "../../../consts";

@Component({
    selector: "app-turnos",
    templateUrl: "./turnos.component.html",
    styleUrls: ["./turnos.component.css"],
    standalone: false
})
export class TurnosComponent implements OnInit {
    // #region Propiedades del componente
    displayedColumns: string[] = [
        "employees_Id",
        "nombre",
        "tipo",
        "cadenaInicio",
        "cadenaFin",
        "acciones",
    ];
    empleados: EmployeesListModel[] = [];
    fechas: string[] = [];
    listaTurnos$: Observable<Turnos[]> = this.TurnosService.listaTurnos$;
    row: Turnos = null;
    routes: object[] = [];

    formRegistro: UntypedFormGroup = null;
    // #endregion

    constructor(
        private router: Router,
        public dialog: MatDialog,
        public EmployeesListService: EmployeesListService,
        public registroHorasService: RegistroHorasService,
        public TurnosService: TurnosService,
        protected snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef
    ) {
        this.routes = EMPLOYEES_ROUTES;
    }

    // #region Métodos del componente

    /**
     * Cancela la solicitud de registro.
     */
    cancelarSolicitudRegistro(): void {
        this.formRegistro.reset();
    }

    /**
     * Crea un nuevo turno.
     */
    create(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        this.dialog.open(TurnosFormComponent, {
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            data: { empleados: this.empleados, turno: null },
        });
    }

    /**
     * Elimina un turno.
     *
     * @param uid - El identificador del turno a eliminar.
     */
    eliminar(uid: number): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        this.dialog
            .open(TurnosEliminarComponent, {
                data: {},
            })
            .afterClosed()
            .subscribe((result: boolean) => {
                if (result) {
                    this.TurnosService.deleteTurno(this.row.id).subscribe();
                }
            });
    }

    /**
     * Abre el diálogo de edición de turnos.
     */
    editar(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        this.dialog.open(TurnosFormComponent, {
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            data: { turno: this.row, empleados: this.empleados },
        });
    }

    ngOnInit() {
        // Obtención de los empleados ...
        this.EmployeesListService.getList(true).then((data) => {
            this.empleados = data;

            // ... y carga de los turnos
            this.TurnosService.getListaTurnos();
            // loading$.next(true) fires synchronously inside getListaTurnos(),
            // detectChanges() captures that value as "checked" before zone.js
            // triggers the next CD pass, preventing NG0100.
            this.cdr.detectChanges();
        });

        this.inicializarFormRegistro();
    }

    /**
     * Devuelve el nombre del empleado correspondiente al UID proporcionado.
     * @param uid El UID del empleado.
     * @returns El nombre del empleado o una cadena vacía si no se encuentra el empleado.
     */
    nombreEmpleado(uid: number): string {
        const empleado = this.empleados.find((e) => e.uid == uid);
        return empleado ? empleado.name : "";
    }

    /**
     * Devuelve el nombre del tipo de turno correspondiente al valor proporcionado.
     * @param tipo El valor del tipo de turno.
     * @returns El nombre del tipo de turno o una cadena vacía si no se encuentra.
     */
    nombreTipoTurno(tipo: number): string {
        const tipoTurno = TIPOS_TURNOS.find((t) => t.valor == tipo);
        return tipoTurno ? tipoTurno.etiqueta : "";
    }

    setRow(row: Turnos): void {
        this.row = row;
    }

    // #endregion

    // #region Métodos privados

    private inicializarFormRegistro() {
        this.formRegistro = new UntypedFormGroup({
            employees_Id: new UntypedFormControl(undefined, [Validators.required]),
            inicio: new UntypedFormControl(undefined, [Validators.required]),
            fin: new UntypedFormControl(undefined, [Validators.required]),
        });
    }

    // #endregion
}
